import React from 'react';

const SvgSuccessExpertBooksYourTrip = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 300 300"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__path-1",
  d: "M9.8 0h136.5c5.412 0 9.8 4.388 9.8 9.8v261.1H0V9.8C0 4.388 4.388 0 9.8 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__path-5",
  d: "M19.055 77.053c1.823-2.52 3.083-5.788 3.131-9.154.048-3.366.018-3.935-.879-6.146l-6.552-1.798c-2.252-.815-4.446-4.398-6.3-10.73L.62 35.857l2.039-25.43-.556-7.941L12.246.665l1.845-.06C33.736.008 45.5 1.35 49.386 4.63c4.006 3.38 5.13 9.346 3.375 17.895l-2.178 13.023c.117 11.152.691 19.363 1.722 24.634 1.031 5.27 3.686 11.457 7.966 18.559l-4.663 14.87-29.042 4.797-15.553-12.055 8.042-9.301z"
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__path-8",
  d: "M0 69.44l10.757-39.602a26.977 26.977 0 017.073-12.119 51.327 51.327 0 0111.552-8.578l.837-.455a64.154 64.154 0 0115.195-5.907L56.347.066c.23 8.138 6.216 12.089 17.96 11.853C86.051 11.684 92.847 8.04 94.694.99L110.53 7.32a34.168 34.168 0 0112.49 8.625 29.103 29.103 0 016.958 13.331l8.972 40.163H0z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__linearGradient-7",
  x1: "50%",
  x2: "50%",
  y1: "71.894%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#59DD7D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#50C871"
})), /*#__PURE__*/React.createElement("rect", {
  id: "tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__path-3",
  width: 140.7,
  height: 207.2,
  x: 0,
  y: 0,
  rx: 2.8
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(45.1 15)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#EDEFF0",
  xlinkHref: "#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__path-1"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#C8CCCF",
  mask: "url(#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(61.6 11.9)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.854 2.1H22.4a.7.7 0 010 1.4H.854a.7.7 0 010-1.4z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30.8,
  cy: 2.8,
  r: 2.8
}))), /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 250.6,
  r: 9.1,
  fill: "#C8CCCF",
  mask: "url(#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-2)"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.7 25.966)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-4",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__path-3"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__path-3"
}), /*#__PURE__*/React.createElement("rect", {
  width: 95.2,
  height: 21,
  x: 24.5,
  y: 169.334,
  fill: "#EDEFF0",
  mask: "url(#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-4)",
  rx: 10.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.7,
  cy: 179.834,
  r: 8.4,
  fill: "#59DD7D",
  mask: "url(#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-4)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#3F4144",
  fillRule: "nonzero",
  mask: "url(#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70.35 30.1c8.698 0 15.75 7.052 15.75 15.75S79.048 61.6 70.35 61.6 54.6 54.548 54.6 45.85 61.652 30.1 70.35 30.1zm7.673 6.462c-.332.275-1.217.579-1.66.579H64.392c-.442 0-1.355-.304-1.714-.58V41.5h.553c.691 0 .857-.138.94-.8l.055-.414c.138-1.214 1.023-1.849 2.627-1.849h1.355V53.06c.028.58-.11.828-.636 1.02l-.47.084c-.387.055-.553.303-.553.91v.47h7.687v-.47c0-.607-.139-.855-.581-.91l-.498-.083c-.442-.083-.663-.442-.663-1.02V38.436h1.078c1.991-.028 2.682.414 2.986 1.849l.056.414c.083.579.276.8.746.8h.664z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#C8CCCF",
  d: "M53.935 74.134h33.53a.735.735 0 110 1.47h-33.53a.735.735 0 010-1.47z",
  mask: "url(#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C8CCCF",
  fillRule: "nonzero",
  d: "M48.629 176.663a.525.525 0 01.683-.051l.06.05 2.798 2.8a.525.525 0 01.051.683l-.05.06-2.8 2.798a.525.525 0 01-.793-.683l.05-.059 2.429-2.428-2.428-2.428a.525.525 0 01-.051-.683l.05-.06zM56.329 176.663a.525.525 0 01.683-.051l.06.05 2.798 2.8a.525.525 0 01.051.683l-.05.06-2.8 2.798a.525.525 0 01-.793-.683l.05-.059 2.429-2.428-2.428-2.428a.525.525 0 01-.051-.683l.05-.06zM63.854 176.488a.525.525 0 01.683-.051l.06.05 2.798 2.8a.525.525 0 01.051.683l-.05.06-2.8 2.798a.525.525 0 01-.793-.683l.05-.059 2.429-2.428-2.428-2.428a.525.525 0 01-.051-.683l.05-.06z",
  mask: "url(#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-4)"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(3 -2562.072 3336.74)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-6",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__path-5"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#EDEFF0",
  xlinkHref: "#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__path-5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D2D7DA",
  d: "M20.223 61.303c4.736.768 8.936 1.023 12.6.768 5.497-.384-7.636 7.002-14.321 4.987",
  mask: "url(#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-6)",
  transform: "rotate(-5 26.319 64.355)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-3 2241.4 -2609.684)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  d: "M38.72 18.64c-12.35 8.834-10.176 20.292-10.176 23.537 0 3.245-8.285 25.558-9.966 29.855-.546 1.395-2.315 4.31 3.844 8.075 1.34-2.848 2.14-5.025 2.399-6.532.436-2.535 1.462 2.38-.117 7.778.438.218.906.438 1.402.66.213.095.422.185.627.268 2.354.956 5.12.956 8.299 0-2.096-6.945-3.384-12.5-3.864-16.665-.755-6.551.139-14.364 2.68-23.44 6.192 1.254 13.282 1.742 21.268 1.465 4.466-.154 8.322.078 11.568.696.178-2.249.167-3.978-.033-5.187-.376-2.273 1.672.966 2.29 5.707 1.61.44 3.038.994 4.284 1.663 1.747 8.318 2.096 14.576 1.047 18.774-1.049 4.197-3.935 9.86-8.657 16.987 5.627.973 10.744 1.441 15.35 1.407 1.262-3.186 1.974-5.581 2.134-7.189.246-2.454 1.522 1.898.565 7.107 5.504-.294 10.21-1.376 14.118-3.245 11.486-5.494 3.149-17.644-.1-25.685-3.249-8.04-1.94-29.99-18.506-39.202-16.567-9.211-28.104-5.667-40.455 3.167z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73.534,
  cy: 66.544,
  r: 2.993,
  fill: "#59DD7D"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(130.5 215.62)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-9",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__path-8"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__linearGradient-7)",
  xlinkHref: "#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__path-8"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-9)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-1 1127.784 -3583.904)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.648,
  cy: 3.395,
  r: 2.695,
  transform: "rotate(2 4.648 3.395)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.395,
  cy: 17.22,
  r: 2.695,
  transform: "rotate(2 3.395 17.22)"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#50C871",
  d: "M24.363 69.02l9.264-23.222L30.62 69.44",
  mask: "url(#tourlane-EnquiryExperience-SuccessExpertBooksYourTrip__mask-9)",
  opacity: 0.8
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#C8CCCF",
  strokeLinecap: "round",
  strokeWidth: 1.05,
  d: "M22 284.85h256.91"
})));

export default SvgSuccessExpertBooksYourTrip;